<template>
  <div v-if="totalPages > 1" class="pagination">
    <button
      class="pagination__btn pagination__btn--nav"
      :disabled="modelValue === 1"
      @click="$emit('update:modelValue', modelValue - 1)"
    >
      ← Anterior
    </button>

    <button
      v-for="page in visiblePages"
      :key="page"
      :class="[
        'pagination__btn',
        {
          'pagination__btn--active': page === modelValue,
          'pagination__btn--ellipsis': page === '...',
        },
      ]"
      :disabled="page === '...'"
      @click="page !== '...' && $emit('update:modelValue', page)"
    >
      {{ page }}
    </button>

    <button
      class="pagination__btn pagination__btn--nav"
      :disabled="modelValue === totalPages"
      @click="$emit('update:modelValue', modelValue + 1)"
    >
      Próximo →
    </button>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'AppPagination',
  props: {
    modelValue: { type: Number, required: true },
    totalItems: { type: Number, required: true },
    itemsPerPage: { type: Number, default: 8 },
  },
  emits: ['update:modelValue'],
  setup(props) {
    const totalPages = computed(() =>
      Math.ceil(props.totalItems / props.itemsPerPage)
    );

    const visiblePages = computed(() => {
      const total = totalPages.value;
      const current = props.modelValue;

      if (total <= 7) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }

      const pages = [1];
      if (current > 3) pages.push('...');

      const start = Math.max(2, current - 1);
      const end = Math.min(total - 1, current + 1);
      for (let i = start; i <= end; i++) pages.push(i);

      if (current < total - 2) pages.push('...');
      pages.push(total);

      return pages;
    });

    return { totalPages, visiblePages };
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 32px;
  flex-wrap: wrap;
}

.pagination__btn {
  min-width: 40px;
  height: 40px;
  padding: 0 12px;
  border-radius: 6px;
  border: 1px solid #ddd;
  background: var(--branco);
  font-family: var(--font-freight);
  font-size: 14px;
  color: var(--cor-textos);
  cursor: pointer;
  transition: border-color 0.2s ease, color 0.2s ease, background-color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination__btn:hover:not(:disabled) {
  border-color: var(--azul-medio);
  color: var(--azul-medio);
}

.pagination__btn--active {
  background: var(--azul-medio);
  border-color: var(--azul-medio);
  color: var(--branco);
  font-weight: var(--weight-semibol);
}

.pagination__btn--active:hover:not(:disabled) {
  background: var(--azul-escuro);
  border-color: var(--azul-escuro);
  color: var(--branco);
}

.pagination__btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.pagination__btn--ellipsis {
  border: none;
  background: transparent;
  cursor: default;
  min-width: 24px;
}

.pagination__btn--nav {
  padding: 0 16px;
}
</style>
